import type { CreateCompanyInput } from "@dutyon/apis";
import { createCompany, queryKeys } from "@dutyon/apis";
import { Button, TitleContainer } from "@dutyon/ui-kit";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyForm } from "../../components/CompanyForm";

export function CompanyCreatePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: CreateCompanyInput) => createCompany(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.companies.all });
      navigate("/companies");
    },
  });

  const initialValues = useMemo(() => {
    if (!location.state || typeof location.state !== "object") return undefined;
    const state = location.state as Record<string, unknown>;

    const getString = (key: string) => {
      const value = state[key];
      return typeof value === "string" ? value : "";
    };

    return {
      name: getString("name"),
      adminName: getString("adminName"),
      adminEmail: getString("adminEmail"),
    };
  }, [location.state]);

  return (
    <TitleContainer
      title="병원 등록"
      rightSection={
        <Button variant="subtle" onClick={() => navigate("/companies")}>
          &lt; 뒤로가기
        </Button>
      }
    >
      <CompanyForm
        initialValues={initialValues}
        onSubmit={(data) =>
          mutation.mutate({
            name: data.name,
            code: data.code,
            adminEmail: data.adminEmail ?? "",
            adminName: data.adminName ?? "",
            adminPassword: data.adminPassword ?? "",
          })
        }
        isLoading={mutation.isPending}
      />
    </TitleContainer>
  );
}
